var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 14a2 2 0 0 1 2 2v7l-.01.204a2 2 0 0 1-1.786 1.785L20 25H10l-.204-.01a2 2 0 0 1-1.785-1.786L8 23v-7a2 2 0 0 1 2-2v-3a5 5 0 0 1 10 0v1h-2v-1a3 3 0 1 0-6 0v3zm-10 9h10v-7H10z"
  })));
};
export default SvgPadlock;